<template>
    <footer class="bg-white dark:bg-slate-900 border-t border-slate-100 dark:border-slate-800 py-6 px-8 mt-auto transition-all">
        <div class="max-w-7xl mx-auto flex flex-col md:flex-row items-center justify-between gap-4">
            <div class="flex flex-col items-center md:items-start">
                <p class="text-sm font-bold text-slate-900 dark:text-white uppercase tracking-tighter">Ticket Smile</p>
                <p class="text-[11px] font-bold text-slate-400 uppercase tracking-widest mt-1">© 2022 - {{ new Date().getFullYear() }} All Rights Reserved</p>
            </div>
            
            <div class="flex flex-col md:flex-row items-center gap-2 md:gap-6">
                <div class="text-[11px] font-bold text-slate-500 uppercase tracking-widest flex items-center gap-2">
                    CNPJ: <span class="text-pink-600">50.516.107/0001-65</span>
                </div>
                <div class="hidden md:block w-px h-4 bg-slate-200 dark:bg-slate-700"></div>
                <div class="flex items-center gap-4">
                    <a href="#" class="text-[11px] font-bold text-slate-400 hover:text-pink-600 transition-colors uppercase tracking-widest">Termos</a>
                    <a href="#" class="text-[11px] font-bold text-slate-400 hover:text-pink-600 transition-colors uppercase tracking-widest">Privacidade</a>
                </div>
            </div>
        </div>
    </footer>
</template>

<script setup>
</script>

<style scoped>
</style>